/**
 * created by cc 批量图上传
 * 2016-3-30
 *last modified by lileilei 2018.3.15
 */
'use strict';
angular.module('watermarkUploadModule', [])
    . controller('watermarkUpladerCtrl', ['$scope', 'modalDialog', '$stateParams', '$element', '$q', 'Upload', '$validation', '$modalInstance', 'trsHttpService', 'obj',
        function($scope, modalDialog, $stateParams, $element, $q, Upload, $validation, $modalInstance, trsHttpService, obj) {
            initStatus();

            /**
             * [initStatus description]初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {};
                $scope.data = {};

            }

            /**
            * [upload description]上传事件
            *
            * @param   {[type]}  file  [file description]
            *
            * @return  {[type]}        [return description]
            */
            $scope.upload = function(file) {
                $scope.loadingPromise = upload(file);
            };

            /**
             * [upload description]上传实现
             *
             * @param   {[type]}  file  [file description]
             *
             * @return  {[type]}        [return description]
             */
            function upload(file) {
                if (!file) {return;}
                var deffer = $q.defer();
                $scope.data.watermarkName = file[0].name;
                Upload.upload({
                    url: '/wcm/openapi/uploadImage?isWaterMark=true',
                    data: {
                        file: file
                    },
                }).then(function(resp) {
                    if (resp.data.ISSUCCESS === 'false') {
                        modalDialog.alertType(resp.data.TITLE, '', 'error', 'confirm');
                        deffer.reject();
                    } else {
                        var imgArray = resp.data.imgSrc.split('/');
                        imgArray.splice(0, 3);
                        $scope.data.watermarkImg = '/' + imgArray.join('/');
                        $scope.data.imgName = resp.data.imgName;
                        handleImageSize().then(function() {
                            deffer.resolve();
                        });
                    }
                }, function(resp) {

                }, function(evt) {

                });
                return deffer.promise;
            }

            /**
         * [handleImageSize description] 处理图片宽高
         * @return {[type]} [description]
         */
            function handleImageSize() {
                var deffer = $q.defer();
                var outerDiv = $element.find('.watermark-alert-box');
                var imgAspectRatio;
                var divAspectRatio = outerDiv.width() / outerDiv.height();
                var img = new Image();
                img.src = $scope.data.watermarkImg;
                img.onload = function() {
                    imgAspectRatio = this.width / this.height;
                    $scope.$apply(function() {
                        if (imgAspectRatio > divAspectRatio) {
                            $scope.status.imgStyle = {
                                height: outerDiv.width() / imgAspectRatio,
                                width: outerDiv.width(),
                                top: (outerDiv.height() - outerDiv.width() / imgAspectRatio) / 2
                            };
                        } else {
                            $scope.status.imgStyle = {
                                height: outerDiv.height(),
                                width: outerDiv.height() * imgAspectRatio
                            };
                        }
                        deffer.resolve();
                    });
                };
                return deffer.promise;
            }

            /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
            $scope.confirm = function() {
                $validation.validate($scope.watermarkForm).success(function() {
                    var params = {
                        ObjectId: 0,
                        serviceid: 'mlf_watermark',
                        methodname: 'saveWaterMark',
                        LibId: $stateParams.site,
                        NotQuickEdit: true,
                        Status: 0,
                        WMName: $scope.data.watermarkName,
                        WMPicture: $scope.data.imgName
                    };
                    if (obj) {
                        params.methodname = 'saveWaterMarkNew';
                        params.productId = $stateParams.site;
                        params.mediaType = obj.mediaType;
                        delete params.LibId;
                    }
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        modalDialog.alertType('新建水印成功', '', 'success', false, function() {
                            $modalInstance.close();
                        });
                    });
                });
            };

            /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
